export default __webpack_public_path__ + "static/media/green-marker.f80ec8f6.svg";